/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Storage_Bar_BaseInputs */



/**
* | output |
* | --- |
* | "Base ({size})" |
*
* @param {Storage_Bar_BaseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const storage_bar_base = /** @type {((inputs: Storage_Bar_BaseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storage_Bar_BaseInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Basis (${i?.size})`)
	return /** @type {LocalizedString} */ (`Base (${i?.size})`)
});